import { render, staticRenderFns } from "./SmsSendTestModal.vue?vue&type=template&id=5250fd9e&scoped=true"
import script from "./SmsSendTestModal.vue?vue&type=script&lang=js"
export * from "./SmsSendTestModal.vue?vue&type=script&lang=js"
import style0 from "./SmsSendTestModal.vue?vue&type=style&index=0&id=5250fd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5250fd9e",
  null
  
)

export default component.exports